import * as yup from "yup";

export const schema = yup
  .object({
    collectionName: yup.string().required(),
  })
  .required();
